<template>
    <div>
    </div>
</template>

<script>
    import betSlip from '@/mixins/betSlip'

    export default {
        name: 'BetSlipWorker',
        mixins: [betSlip],
        data() {
            return {
            }
        },
        methods: {
            isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        },
        watch: {
            '$store.state.updateMarket' (m) {
              if(this.isJsonString(m)){
                this.$getItem('bets', (key, value) => {
                    //console.log all the kay/value pairs
                    this.bets = value
                }, function (err) {
                })
                var market = JSON.parse(m)
                market.forEach( (market,k) => {
                  market.selections.forEach( (v,k) => {
                    var objIndex = this.bets.findIndex(obj => obj.oddId == v.id);
                    if(objIndex >= 0){
                      this.bets[objIndex].active = !v.isDisabled
                      if(v.value <= 1){
                        this.bets[objIndex].active = false
                      }
                      this.bets[objIndex].odd = v.value
                      this.$set(this.bets, objIndex, this.bets[objIndex])
                      this.$store.commit("updateBetslip", this.bets);
                      this.updateBets(this.bets)
                    }
                  })
                })
              }
            },
        },
        mounted() {
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/BetSlipWorker.vue